module.exports = __webpack_public_path__ + "static/app-store-dark-73bd4426623540ceadb8195e0e662885.svg";